// extracted by mini-css-extract-plugin
export default {"background":"SignInLayout_background__IDkfF","innerLayout":"SignInLayout_innerLayout__qm+E7"};